"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HorizontalLineSpacer;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _excluded = ["thickness", "color", "style"]; // import { HorizontalLine } from '@sart/icons'
function HorizontalLineSpacer(props) {
  var thickness = props.thickness,
    color = props.color,
    style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var containerStyles = [styles.container, style];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, (0, _extends2["default"])({
    style: containerStyles
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.line, {
      height: thickness,
      backgroundColor: color
    }]
  }));
}
HorizontalLineSpacer.defaultProps = {
  thickness: 1,
  color: _styles.backgroundColors.subtle
};
HorizontalLineSpacer.propTypes = {
  thickness: _propTypes["default"].number,
  color: _propTypes["default"].string,
  style: _propTypes["default"].any
};
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 24,
    justifyContent: 'center'
  },
  line: {}
});